import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { ValidationProvider } from '@services/helpers/validation.service';
import { ConfirmGeneralModalComponent } from '@web-components/common/confirm-general-modal/confirm-general-modal.component';
import { SNModalService } from '@web-services/modal/snModal.service';
import { PaymentMethodsDataProvider } from '@web-services/settings/payment-methods/payment-methods.data.service';

@Component({
	selector: 'payment-methods',
	template: require('./payment-methods.component.html'),
	styles: [require('./payment-methods.component.scss')]
})
export class PaymentMethods implements OnInit {
	constructor(
		private http: HttpClient,
		private pmDataService: PaymentMethodsDataProvider,
		private messageService: MessageService,
		private validationService: ValidationProvider,
		private modalService: SNModalService
	) {}
	isSaveSpinnningWheelActive = false;
	isDeleteSpinnerActive = false;
	paymentMethods = [];
	button_disable = false;
	stripePaymentMethod: any = {};
	paypalPaymentMethod: any = {};
	activeBankTransferTab: any = {};
	activeOtherTab: any = {};
	hasStripe = false;
	hasPayPal = false;
	breadcrumbs = [
		{ link: '/', title: 'Dashboard' },
		{ link: '/settings', title: 'Settings' },
		{ link: null, title: 'Payment Methods' }
	];

	ngOnInit(): void {
		this.getAllPaymentMethods();
		this.getPaymentInstructions();
	}

	getAllPaymentMethods() {
		this.pmDataService
			.getAllPaymentMethods()
			.then(result => {
				this.setPaymentMethods(result);
			})
			.catch(err => {
				this.messageService.showDefaultErrorMessage(err);
			});
	}

	getPaymentInstructions() {
		this.pmDataService
			.getPaymentInstructions()
			.then(res => this.setPaymentInstructions(res))
			.catch(e => {
				this.messageService.showDefaultErrorMessage(e);
			});
	}

	setPaymentInstructions({ paymentMethods }: any) {
		this.paymentMethods = paymentMethods;
		this.paymentMethods.forEach(method => {
			if (method.active) {
				const firstInvalid = method.languages.find(
					lang => !this.isMethodValid(lang)
				);
				if (firstInvalid) {
					firstInvalid.active = true;
					this.selectTab(firstInvalid.language.displayName, method.methodType);
				} else {
					method.languages[0].active = true;
				}
			} else {
				method.languages[0].active = true;
			}
			const languages = method.languages;
			languages.forEach(language => {
				if (
					language.language.displayName ===
						this.activeBankTransferTab.tabTitle &&
					method.methodType === this.activeBankTransferTab.methodType
				) {
					method.languages[0].active = false;
					language.active = true;
				}
				if (
					language.language.displayName === this.activeOtherTab.tabTitle &&
					method.methodType === this.activeOtherTab.methodType
				) {
					method.languages[0].active = false;
					language.active = true;
				}
			});
		});
	}

	selectTab(languageName, methodType) {
		if (methodType === 'BANK_TRANSFER_INSTRUCTIONS') {
			this.activeBankTransferTab = {
				tabTitle: languageName,
				methodType
			};
		}

		if (methodType === 'OTHER_INSTRUCTIONS') {
			this.activeOtherTab = {
				tabTitle: languageName,
				methodType
			};
		}
	}

	setPaymentMethods(methods) {
		if (!methods.length) {
			return;
		}

		this.stripePaymentMethod = this.findMethodByType('STRIPE', methods);
		this.paypalPaymentMethod = this.findMethodByType('PAYPAL', methods);

		if (this.stripePaymentMethod) {
			this.hasStripe = true;
		} else {
			this.stripePaymentMethod = {};
		}

		if (this.paypalPaymentMethod) {
			this.hasPayPal = true;
		} else {
			this.paypalPaymentMethod = {};
		}
	}

	findMethodByType(type, methods) {
		return methods.find(method => method.type === type);
	}

	showDeactivatePaypal() {
		$('#delPayPalModal').modal('show');
	}

	deactivatePaypalModal() {
		this.hasPayPal = false;
		delete this.paypalPaymentMethod.paypalEmail;
		$('#delPayPalModal').modal('hide');
		this.savePayPalRequest();
	}

	showLinkInNewTab(link) {
		window.open(link);
	}

	showDeactivate() {
		$('#delStripeModal').modal('show');
	}

	deactivateStripeModal() {
		this.hasStripe = false;
		delete this.stripePaymentMethod.stripePublicKey;
		delete this.stripePaymentMethod.stripeSecretKey;
		$('#delStripeModal').modal('hide');
		this.saveStripeRequest();
	}

	isMethodValid(language) {
		const { nameOfMethod, instructions: { htmlValue = '' } = {} } = language;

		if (nameOfMethod !== undefined && nameOfMethod !== null) {
			if (!nameOfMethod.text || nameOfMethod.text.trim() === '') {
				return false;
			}
		}

		if (!htmlValue || htmlValue.trim() === '') {
			return false;
		}

		return true;
	}

	preparePaymentMethods2Save(method2Save) {
		const method = JSON.parse(JSON.stringify(method2Save));
		if (!method.active) {
			method.active = false;
		}

		method.languages.forEach(el => {
			el.language = el.language.name;
		});
		return method;
	}

	checkPayments(payments) {
		return payments.some(el => {
			if (el.active && el.languages.some(lang => !this.isMethodValid(lang))) {
				this.messageService.showToaster('e_6', 'paymentMethods', el.title);
				return true;
			}
			return false;
		});
	}

	savePaymentMethods() {
		this.isSaveSpinnningWheelActive = true;
		const payments = this.paymentMethods;

		if (this.checkPayments(payments)) {
			this.isSaveSpinnningWheelActive = false;
			return;
		}

		const methodsToSave = payments.map(this.preparePaymentMethods2Save);
		this.pmDataService
			.savePaymentMethods({
				paymentMethods: methodsToSave
			})
			.then(data => {
				this.messageService.showToaster('s_2', 'paymentMethods');
				this.isSaveSpinnningWheelActive = false;
				this.setPaymentInstructions(data);
			})
			.catch(err => {
				if (err.status !== 401) {
					this.messageService.showDefaultErrorMessage(err);
				}
			})
			.finally(() => {
				this.isSaveSpinnningWheelActive = false;
			});
	}

	openDeleteModal(deleteData) {
		if (deleteData.method === 'ALERT_MODAL' && deleteData.alertMessage) {
			this.openAlertModal(
				deleteData.alertMessage.message,
				deleteData.alertMessage.title
			);
		} else {
			if (!deleteData.withConfirmationMessage) {
				this.deleteLang(deleteData.url);
				return;
			}

			const {
				withConfirmationMessage: {
					messageHTML,
					buttons: { cancelBtn, confirmBtn }
				},
				url
			} = deleteData;

			const modal = this.modalService.openModal(ConfirmGeneralModalComponent);

			modal.componentInstance.htmlText = true;
			modal.componentInstance.text = messageHTML;
			modal.componentInstance.buttons = [
				{
					text: confirmBtn.name,
					color: 'success',
					size: 'lg',
					action: 'DELETE'
				},
				{
					text: cancelBtn.name,
					color: 'default',
					size: 'lg',
					action: 'CANCEL'
				}
			];

			modal.result.then((action: string): void => {
				if (action === 'DELETE') {
					this.deleteLang(url);
				}
			});
		}
	}

	private openAlertModal(message: string, title: string): void {
		const modal = this.modalService.openModal(ConfirmGeneralModalComponent, {
			windowClass: 'ng-bootstrap-modal modal-visible modal-narrow'
		});
		modal.componentInstance.text = message;
		modal.componentInstance.title = title;
		modal.componentInstance.htmlText = true;

		modal.componentInstance.buttons = [
			{
				text: 'Got it!',
				action: 'CLOSE',
				color: 'default',
				size: 'lg'
			}
		];
	}

	deleteLang(url) {
		this.isSaveSpinnningWheelActive = true;
		this.isDeleteSpinnerActive = true;
		this.pmDataService
			.deleteLang(url)
			.then(res => {
				this.setPaymentInstructions(res.data);
			})
			.catch(e => {
				this.messageService.showDefaultErrorMessage(e);
			})
			.finally(() => {
				this.isSaveSpinnningWheelActive = false;
				this.isDeleteSpinnerActive = false;
			});
	}

	openStripeModal() {
		this.pmDataService.getPaymetMethodByType('STRIPE').then((result: any) => {
			this.stripePaymentMethod = result || {};
			$('#addStripeModal').modal('show');
		});
	}

	saveStripeMethod() {
		if (
			!this.stripePaymentMethod ||
			!this.stripePaymentMethod.stripeSecretKey ||
			!this.stripePaymentMethod.stripePublicKey
		) {
			this.messageService.showToaster('e_4', 'paymentMethods');
		} else {
			this.saveStripeRequest();
		}
	}

	saveStripeRequest() {
		this.button_disable = true;
		const stipeMethod = this.stripePaymentMethod;
		const isStripeActive =
			stipeMethod.stripePublicKey && stipeMethod.stripeSecretKey;
		this.pmDataService
			.saveStripeRequest(this.stripePaymentMethod)
			.then(result => this.successSaveStripe(result, isStripeActive))
			.catch(result => this.errorSaveStripe(result))
			.finally(() => {
				this.button_disable = false;
			});
	}

	successSaveStripe(data, isStripeActive) {
		if (isStripeActive) {
			this.hasStripe = true;
		}
		$('#addStripeModal').modal('hide');
		this.messageService.showToaster('s_1', 'paymentMethods');
	}

	errorSaveStripe(result) {
		if (result.status === 422) {
			this.messageService.showToaster('e_2', 'paymentMethods');
		} else {
			this.messageService.showToaster('e_0', 'general');
		}
	}

	openPaypalModal() {
		this.pmDataService.getPaymetMethodByType('PAYPAL').then((result: any) => {
			this.paypalPaymentMethod = result || {};
			$('#addPaypalModal').modal('show');
		});
	}

	savePaypalMethod() {
		if (
			this.paypalPaymentMethod &&
			this.validationService.isStringEmpty(this.paypalPaymentMethod.paypalEmail)
		) {
			return this.messageService.showToaster('e_3', 'paymentMethods');
		}

		if (this.paypalPaymentMethod == '') {
			$('#addPaypalModal').modal('hide');
			toastr.success('No changes');
		} else {
			this.hasPayPal = true;
			this.savePayPalRequest();
		}
	}

	savePayPalRequest() {
		this.button_disable = true;
		this.pmDataService
			.savePayPalRequest(this.paypalPaymentMethod)
			.then(result => this.successSavePayPal(result))
			.catch(result => this.errorSavePayPal(result))
			.finally(() => {
				this.button_disable = false;
			});
	}

	successSavePayPal(data) {
		$('#addPaypalModal').modal('hide');
		this.messageService.showToaster('s_0', 'paymentMethods');
	}

	errorSavePayPal(result) {
		if (result.status === 422) {
			this.messageService.showToaster('e_7', 'paymentMethods');
		} else {
			this.messageService.showToaster('e_0', 'general');
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/payment-methods/payment-methods.component.ts